import { domready } from './domready'

const FORM_SELECTOR = '.js-ip-allowlist-form'
const ROW_SELECTOR = '.js-ip-allowlist-row'
const INPUT_SELECTOR = '.js-ip-allowlist-cidr'
const ERROR_SELECTOR = '.c-form-row_error'

function setError(row: Element, input: Element, message: string): void {
  row.classList.add('error')
  row.querySelectorAll(ERROR_SELECTOR).forEach(node => node.remove())

  const error = document.createElement('div')
  // --stacked keeps the message aligned with the input (no label-width offset), matching the
  // server-rendered error. Insert it directly after the input so it sits above the submit button.
  error.className = 'c-form-row_error c-form-row_error--stacked'
  const paragraph = document.createElement('p')
  paragraph.textContent = message
  error.appendChild(paragraph)
  input.insertAdjacentElement('afterend', error)
}

function clearError(row: Element): void {
  row.classList.remove('error')
  row.querySelectorAll(ERROR_SELECTOR).forEach(node => node.remove())
}

function enableSubmitControl(
  submitButton: HTMLButtonElement | HTMLInputElement | null
): void {
  if (!submitButton) return
  submitButton.disabled = false
  submitButton.removeAttribute('disabled')
  submitButton.classList.remove('is-disabled')
}

// Client-side validation is intentionally limited to a presence check. The structural CIDR
// validation (IPv4/IPv6 shape, prefix range, allow-all rejection) lives in the IpAllowlistEntry
// model so there is a single, tested source of truth; the server re-renders the form with its
// own error message when the value is malformed.
domready(function initIpAllowlistValidation() {
  const form = document.querySelector<HTMLFormElement>(FORM_SELECTOR)
  if (!form) return

  const input = form.querySelector<HTMLInputElement>(INPUT_SELECTOR)
  const submitButton = form.querySelector<HTMLButtonElement | HTMLInputElement>(
    'button[type="submit"], input[type="submit"]'
  )
  const row = form.querySelector(ROW_SELECTOR)
  if (!input || !row) return

  input.addEventListener('input', () => {
    enableSubmitControl(submitButton)
    if (input.value.trim() !== '') clearError(row)
  })

  form.addEventListener('submit', event => {
    if (input.value.trim() !== '') return

    event.preventDefault()
    // Rails UJS may disable submits before custom validation cancels submission.
    // Ensure the button is interactive again after a validation failure.
    enableSubmitControl(submitButton)
    setError(
      row,
      input,
      'Please enter at least one CIDR block, e.g. 192.168.1.0/24.'
    )
  })
})
